import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../../app/store";
import { API_URL } from "../../config";
import { DailyBudget, DailyBudgetResponse, UpdateDailyBudgetRequest } from "../../types/types";

export enum BudgetTagTypes {
  DAILY_BUDGET = "DailyBudget",
  DAILY_RESUME = "DailyResume",
}

export const budgetApi = createApi({
  reducerPath: "budget",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: [BudgetTagTypes.DAILY_BUDGET, BudgetTagTypes.DAILY_RESUME],
  endpoints: (builder) => ({
    getDailyResume: builder.query<DailyBudgetResponse, { date: string }>({
      query: ({ date }) => ({
        url: `dailyResume?date=${date}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { date }) => [
        { type: BudgetTagTypes.DAILY_RESUME, id: date },
      ],
    }),
    getDailyBudgetList: builder.query<DailyBudget[], void>({
      query: () => ({
        url: "dailyBudget",
        method: "GET",
      }),
      providesTags: [BudgetTagTypes.DAILY_BUDGET],
    }),
    updateDailyBudget: builder.mutation<DailyBudgetResponse, UpdateDailyBudgetRequest>({
      query: ({ date, ...body }) => ({
        url: `dailyBudget/${date}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { date }) => [
        BudgetTagTypes.DAILY_BUDGET,
        { type: BudgetTagTypes.DAILY_RESUME, id: date },
      ],
    }),
  }),
});

export const { useGetDailyResumeQuery, useGetDailyBudgetListQuery, useUpdateDailyBudgetMutation } =
  budgetApi;

export default budgetApi;
